export default {
  experian: 'Experian',
  creditReport: 'Credit Report',
  experianCreditReport: 'Experian Credit Report',
  creditLock: 'CreditLock',
  creditScore: 'Credit Score',
  experianCreditScore: 'Experian Credit Score',
};
